<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-item :label="'日期'" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-range-picker
                v-model="queryParam.dataDt"
                format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>


          <a-col :md="7" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        bordered
        @change="handleTableChange">
      </a-table>

    </div>
    <RefundTradeModal ref="modalForm" @ok="modalFormOk"></RefundTradeModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getOrderLoanStatisticsList } from '@/webpublicapi/statistics'
import Dict from '../modules/Dict';
import RefundTradeModal from './modules/RefundTradeModal'
import moment from "moment";
import exportFile from "@/webpublicapi/exportFile";
export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict
  },
  data () {
    return {
      visible: false,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      // 查询条件
      queryParam: {
        dataDt: [moment().add('days', -6), moment().add('days', 1)],
      },
      loading: false,
      // 表头
      columns: [
        {
          title: '日期',
          align: 'right',
          dataIndex: 'createdTime'
        },
        {
          title: '当日放款额',
          align: 'right',
          dataIndex: 'todayLending',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '当日回款',
          align: 'right',
          dataIndex: 'todayReceivePayment',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '当日现金流',
          align: 'right',
          dataIndex: 'todayCapitalFlow',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '未到期订单本金',
          align: 'right',
          dataIndex: 'unfiredOrdersPrincipal',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '未到期订单(合同额)',
          align: 'right',
          dataIndex: 'unfiredOrdersContractFee',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '截至S1未还款订单(合同额)',
          align: 'right',
          dataIndex: 's1UnpaidPayments',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '截至S2未还款订单(合同额)',
          align: 'right',
          dataIndex: 's2UnpaidPayments',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '过去6天放款本金',
          align: 'right',
          dataIndex: 'beforeLendingPrincipal',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        },
        {
          title: '过去6天放款合同款',
          align: 'right',
          dataIndex: 'beforeLendingContractFee',
          customRender: (text) => {
            if (text == null) return '-';
            const num = Number(text);
            return isNaN(num)
              ? text
              : Math.round(num).toLocaleString('en-US', { maximumFractionDigits: 0 });
          }
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created () {
    this.loadData(1)
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getOrderLoanStatisticsList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows

          // for(var i = 0; i < this.dataSource.length ; i ++){
          //   this.dataSource[i].todayLending = (this.dataSource[i].todayLending * 100).toFixed(2);
          //   this.dataSource[i].todayReceivePayment = (this.dataSource[i].todayReceivePayment * 100).toFixed(2);
          //   this.dataSource[i].todayCapitalFlow = (this.dataSource[i].todayCapitalFlow * 100).toFixed(2);
          //
          //   this.dataSource[i].profitAmount = (this.dataSource[i].repayAmt - this.dataSource[i].paymentAmt).toFixed(2);
          // }

        }else{
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    getQueryParams () {
      const { dataDt } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt;
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange (pagination, filters, sorter) {
      // TODO 筛选
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset () {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // model回调
    modalFormOk () {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    downLoadData (arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/statistics/appAllCountForDateExcel?startDate=' + params.startDate + '&endDate=' + params.endDate,
        fileName: 'appAllCountExcel.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
</style>
